module.exports = __webpack_public_path__ + "static/media/senegal3w.bdf15132.jpg";